import React from "react";
import { formatCurrencyAbs, formatAccountSubtype } from "../../utils/formatters";

export default function AccountCard({ name, subtitle, value, isLiability, onClick }) {
    const hasBalance = value > 0;
    const displayValue = isLiability && hasBalance ? `-${formatCurrencyAbs(value)}` : formatCurrencyAbs(value);
    const valueColor = isLiability && hasBalance ? "text-danger-500" : "text-gray-900";

    return (
        <div
            onClick={onClick}
            className="card p-4 cursor-pointer transition-colors hover:border-gray-300 hover:bg-gray-50"
        >
            <h4 className="font-semibold text-gray-900 truncate">{name}</h4>
            <p className="text-sm text-gray-500 mt-1">{formatAccountSubtype(subtitle)}</p>
            <p className={`text-xl font-semibold mt-2 tracking-tight ${valueColor}`}>
                {displayValue}
            </p>
        </div>
    );
}
